/**
 * Import all actions sagas
 */
import partnerAgreementRoot from "../PartnerAgreement/saga";
import partnerAgreementRoutes from "../PartnerAgreement/sagaRoute";

/**
 * Create array saga
 * @type {*[]}
 */
const sagas = [partnerAgreementRoot, partnerAgreementRoutes];

/**
 * Combine all sagas in one to export to store
 * @param sagaMiddleware
 */
export const combinedSagas = (sagaMiddleware) =>
  sagas.forEach(sagaMiddleware.run.bind(sagaMiddleware));



// WEBPACK FOOTER //
// ./src/modules/Setup/MainSaga.js